/**
 * Generates a reproducible color palette with high visual contrast.
 *
 * @param {number} count - Number of distinct colors to generate.
 * @returns {string[]} Array of HSL color strings.
 *
 * @description
 * Uses the golden angle (≈137.5°) to distribute hues evenly around the color wheel, 
 * ensuring perceptually distinct colors for multi-series charts.
 * 
 * Logic notes:
 * - Always starts from a hue opposite the base (210° → 30°) for contrast against the brand color.
 * - Colors are stable across runs (deterministic output).
 * - Output is directly usable in Chart.js (Canvas supports HSL).
 */
export const getMultiAxisPlottingColors = (count) => {
    const colors = [];

    // Variation angle which generates evenly dsitributed contrast colors.
    const goldenAngle = 137.508;

    // Base hue similar to primary color. From it it will create a high-contrast start hue. This ensures color reproducibility.
    const baseHue = 210;
    const startHue = (baseHue + 180) % 360;

    const saturation = 60;
    const lightness = 50;

    for (let i = 1; i < count; i++) {
        const hue = (startHue + i * goldenAngle) % 360;
        colors.push(`hsl(${hue}, ${saturation}%, ${lightness}%)`);
    }

    return colors;
}